import { motion } from 'framer-motion';
import { RELICS } from './relics';
import RelicIcon from './RelicIcon';

const RelicActivation = ({
  activation,
  index = 0,
  label = 'RELIC ACTIVATED',
  reduceMotion = false,
  showDescription = false,
}) => {
  const relic = RELICS[activation.id];
  const name = activation.name || relic?.name || 'Relic';

  return (
    <motion.div
      className={`coreboundRelicFeedback coreboundRelicFeedback-${activation.id}`}
      initial={reduceMotion ? false : { opacity: 0, y: 18, scale: 0.82 }}
      animate={
        reduceMotion
          ? {}
          : {
              opacity: 1,
              y: 0,
              scale: [0.82, 1.06, 1],
            }
      }
      transition={{
        duration: 0.55,
        delay: reduceMotion ? 0 : index * 0.18,
        ease: 'easeOut',
      }}
    >
      <span className="coreboundRelicFeedbackIcon" aria-hidden="true">
        <RelicIcon
          relicId={activation.id}
          icon={activation.icon || RELICS[activation.id]?.icon || '◆'}
        />
      </span>
      <span className="coreboundRelicFeedbackCopy">
        <small>{label}</small>
        <strong>{name}</strong>
        {showDescription && relic?.description && (
          <span>{relic.description}</span>
        )}
        <span>{activation.message}</span>
      </span>
    </motion.div>
  );
};

export default RelicActivation;
